import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PreviousOrdersModal.module.scss';

import { Modal } from 'components/Modal';
import { ModalHeader } from 'components/ModalHeader/ModalHeader';
import { ShimmerCard } from 'components/ShimmerCard/ShimmerCard';
import { useOrderHistory } from 'hooks/context/OrderHistory';
import { useCloseNavigate } from 'hooks/useCloseNavigate/useCloseNavigate';
import { PreviousOrderCard } from 'routes/Menu/PreviousOrderCard/PreviousOrderCard';
import { RouteFC } from 'util/routeTypes';
import { PREVIOUS_ORDERS_MODAL } from './const';

export const PreviousOrdersModal: RouteFC = ({ path }) => {
  const { t } = useTranslation();
  const { orders, loading } = useOrderHistory();
  const onClose = useCloseNavigate(path);

  useEffect(() => {
    if (!loading && orders.length === 0) {
      onClose();
    }
  }, [orders, loading, onClose]);

  if (!loading && orders.length === 0) return null;

  return (
    <Modal
      aria={{ labelledby: PREVIOUS_ORDERS_MODAL.id }}
      isOpen
      className={styles.modal}
      onClose={onClose}
    >
      <ModalHeader onClose={onClose} data-testid={PREVIOUS_ORDERS_MODAL.title} id={PREVIOUS_ORDERS_MODAL.id}>{t('previousOrder.title')}</ModalHeader>
      <div className={styles.container} >
        {loading ? Array.from(Array(3).keys()).map((i) => <ShimmerCard key={i} className={styles.card} />) : orders.map(order => (
            <PreviousOrderCard
              key={order.id}
              className={styles.card}
              order={order}
              onClick={onClose}
            />
        ))}
      </div>
    </Modal>
  );
};
